import React from 'react';
import { Box } from '@material-ui/core';

const cx = (...classNames) => classNames.filter(Boolean).join(' ');

const NotificationTabs = ({ tabs, activeTab, onTabChange }) => (
    <Box className="notification-page-tabs">
        {tabs.map(tab => (
            <Box key={tab.key} component="button" type="button" onClick={() => onTabChange(tab.key)} className={cx('notification-page-tab', activeTab === tab.key && 'is-active')}>
                {tab.label}
                <Box component="span" className="notification-page-tab-count">{tab.count}</Box>
            </Box>
        ))}
    </Box>
);

export default NotificationTabs;
